import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import { useUser } from '~/providers/user';
import { useContentLibrary } from '../../providers/content_library_provider';
import ClauseSearchResults from './clause_search_results';
import DocumentSearch from './document_search';
const Results = () => {
    const { useNewView } = useUser();
    const { isSearchInProgress, searchedClauses, oldQueryInfo, oldSearchedDocuments, searchedDocuments, queryInfo, } = useContentLibrary();
    if (isSearchInProgress) {
        return (React.createElement("div", { className: 'loading-results', "data-public": true },
            React.createElement(LoadingElement, { isLightBackground: true, large: true }),
            React.createElement("h3", null, "Loading Search Results...")));
    }
    const hasDocumentResults = useNewView
        ? (searchedDocuments === null || searchedDocuments === void 0 ? void 0 : searchedDocuments.length) && queryInfo
        : (oldSearchedDocuments === null || oldSearchedDocuments === void 0 ? void 0 : oldSearchedDocuments.length) && oldQueryInfo;
    const hasClauseResults = (searchedClauses === null || searchedClauses === void 0 ? void 0 : searchedClauses.length) && oldQueryInfo;
    const hasAnySearchResults = hasDocumentResults || hasClauseResults;
    if (!hasAnySearchResults) {
        return (React.createElement("div", { className: 'results-container', "data-public": true },
            React.createElement("div", { className: 'no-search-results' },
                React.createElement("span", null,
                    React.createElement("span", { className: 'fa-lg far fa-search search-icon' })),
                React.createElement("span", { style: { color: '#717171', fontSize: '25px' } }, searchedClauses === null && oldSearchedDocuments === null
                    ? 'Your search results will appear here'
                    : 'Your search did not return any results'))));
    }
    return (React.createElement("div", { className: 'results-container' },
        hasClauseResults &&
            React.createElement(ClauseSearchResults, { clauses: searchedClauses, queryInfo: oldQueryInfo }),
        hasDocumentResults && React.createElement(DocumentSearch, null)));
};
export default Results;
